import React from 'react';
import { motion } from 'framer-motion';
import { ListIcon, CheckIcon } from './icons';
export function BenefitsTable() {
  const benefits = [{
    feature: 'Disponibilidad 24/7',
    benefit: 'Emergencias atendidas — sin esperar días'
  }, {
    feature: 'Geovanny supervisa personalmente',
    benefit: 'Tranquilidad de que el trabajo se hace bien'
  }, {
    feature: 'Presupuesto claro',
    benefit: 'Sin sorpresas. Sin costos ocultos'
  }, {
    feature: 'Servicios múltiples',
    benefit: 'Un solo contratista para todo — menos estrés'
  }, {
    feature: 'Local en Hyattsville/New Carrollton',
    benefit: 'Conocen tu área, están cerca, llegan rápido'
  }, {
    feature: 'Experiencia en remodelación Y restauración',
    benefit: 'No solo arreglan — transforman'
  }];
  return <section className="py-24 bg-brand-bg-light" data-id="element-21">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-23">
          <div className="flex items-center justify-center gap-4 mb-16" data-id="element-24">
            <ListIcon className="w-10 h-10 text-brand-green" data-id="element-25" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-26">
              Beneficios Traducidos a Tu Vida Real
            </h2>
          </div>

          <div className="bg-brand-bg-dark rounded-2xl border border-brand-green/20 overflow-hidden shadow-2xl" data-id="element-27">
            {/* Desktop Table Header */}
            <div className="hidden md:grid grid-cols-2 bg-brand-green-dark/50 border-b border-brand-green/30 p-6" data-id="element-28">
              <h3 className="text-xl font-heading font-bold text-brand-gold uppercase tracking-wider" data-id="element-29">
                Beneficio del Servicio
              </h3>
              <h3 className="text-xl font-heading font-bold text-white uppercase tracking-wider" data-id="element-30">
                Lo que Significa Para Ti
              </h3>
            </div>

            {/* Table Body */}
            <div className="divide-y divide-gray-800" data-id="element-31">
              {benefits.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.05
            }} className="grid md:grid-cols-2 p-6 hover:bg-white/5 transition-colors group" data-id="element-32">
                  <div className="flex items-center gap-3 mb-2 md:mb-0" data-id="element-33">
                    <CheckIcon className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-34" />
                    <span className="text-lg font-medium text-gray-200 group-hover:text-brand-gold transition-colors" data-id="element-35">
                      {item.feature}
                    </span>
                  </div>
                  <div className="flex items-center text-lg text-gray-400 md:pl-6 md:border-l border-gray-800" data-id="element-36">
                    {item.benefit}
                  </div>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}